<template>
    <div id="quick-deposit" class="quick-deposit" />
</template>

<style lang="scss" scoped>
    .quick-deposit {
        position: fixed;
        z-index: 1290;
    }
</style>
